export default __webpack_public_path__ + "static/media/cloud_Upload.9af269a0.svg";